import { Documentation } from "../../../common/store/generalTypes";
import { BasicProps } from "@components/ComponentsInterface";

export const FaqList = ({ faqs }: FaqListProps): JSX.Element => {
    return (
        <div className="has-background-success-light pt-4 px-6">
            {faqs.map((faq) => {
                return (
                    <div key={faq.id} className="pb-4">
                        <div className="has-text-grey-darker has-text-weight-semibold pb-2">Q: {faq.title}</div>
                        <div className="">
                            <span className="is-hidden-custom">Q: </span> {faq.description}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

interface FaqListProps extends BasicProps {
    faqs: Documentation[];
}
